import { fetcher } from '@/services/graphql/fetcher/index';
import type { SettingKey } from '@/types';
import {
  fetchProdcutVariantsDocument,
  fetchProductDetailDocument,
  fetchProductListOptionsDocument,
  fetchActiveProductListOptionsDocument,
  fetchProductsSortByProductIdsDocument,
  fetchSettingsDocument,
  fetchActivityCountdownByProductDocument,
} from '../graphql/docs';

/**
 * 获取商品详情
 * @param id - 商品id
 */
export const fetchProductDetails = async (id: string) => {
  const res = await fetcher.query(fetchProductDetailDocument, {
    variables: { id },
  });
  return res.data.value?.product;
};

/**
 * 获取商品规格
 * @param id - 商品id
 */
export const fetchProdcutVariants = async (id: string) => {
  const res = await fetcher.query(fetchProdcutVariantsDocument, {
    variables: { id },
  });
  return res.data.value?.product;
};

/**
 * 获取 是否包含产品id 的商品数据
 * @param include - 是否包含
 * @param productIds - 产品ids
 * @returns
 */
export const fetchIncludeProductsList = async (
  include?: boolean,
  productIds?: string[],
  take = 50
) => {
  const idConf =
    typeof include === 'undefined' ? {} : include ? { in: productIds } : { notIn: productIds };
  const res = await fetcher.query(fetchProductListOptionsDocument, {
    variables: {
      options:
        typeof include === 'undefined'
          ? { take }
          : {
              take,
              filter: {
                id: idConf,
              },
            },
    },
  });
  return res.data.value?.products?.items;
};

/**
 * 获取 是否包含产品id 的商品数据 - 自定义排序
 * @param include - 是否包含
 * @param productIds - 产品ids
 * @returns
 */
export const fetchProductsSortByProductIds = async (
  include?: boolean,
  productIds?: string[],
  take = 50
) => {
  const idConf =
    typeof include === 'undefined' ? {} : include ? { in: productIds } : { notIn: productIds };
  const res = await fetcher.query(fetchProductsSortByProductIdsDocument, {
    variables: {
      options:
        typeof include === 'undefined'
          ? { take }
          : {
              take,
              filter: {
                id: idConf,
              },
            },
    },
  });
  return res.data.value?.productsSortByProductIds?.items;
};

/** 获取适用商品数据 */
export const fetchSuitProductsList = async (
  options: AnyObject,
  promotionType: string,
  isExchange: boolean
) => {
  const res = await fetcher.query(fetchActiveProductListOptionsDocument, {
    variables: {
      options,
      promotionType,
      isExchange,
    },
  });
  return res.data.value?.activeProducts?.items;
};

/**
 * 获取精选配置商品
 * @param keyNames
 */
export const fetchSettings = async (keyNames: SettingKey[]) => {
  const res = await fetcher.query(fetchSettingsDocument, {
    variables: {
      keyNames,
    },
  });
  return res.data.value?.settings;
};

/**
 * 获取商品倒计时活动
 * @param id - 商品id
 */
export const fetchActivityCountdownByProduct = async (productId: string) => {
  const res = await fetcher.query(fetchActivityCountdownByProductDocument, {
    variables: { productId },
  });
  return res.data.value?.activityCountdownByProduct;
};
